import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, styled } from '@arpeggi/ui'

const ApiAlert = () => {
  return (
    <Alert status="error">
      <AlertIcon />
      <AlertTitle>An error occurred.</AlertTitle>
      <AlertDescription>Make sure your from url is unique.</AlertDescription>
    </Alert>
  )
}

const StyledFormContainer = styled(Box, { display: 'flex', flexDirection: 'column', gap: '16px' })

export const CreateRedirectForm = {
  ApiAlert,
  Container: StyledFormContainer
}
